import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useAdminWatchlistCompaniesQuery } from '../../api/admin';
import AdminQuickFilterToolbar from './AdminQuickFilterToolbar';

interface Props {
	watchlistId: number;
}

export default function WatchlistCompaniesTable({ watchlistId }: Props) {
	const { data: companies, isLoading } = useAdminWatchlistCompaniesQuery(watchlistId);

	const columns: GridColDef[] = [
		{
			field: 'symbol',
			headerName: 'Ticker',
			flex: 0.5,
			minWidth: 90,
		},
		{
			field: 'name',
			headerName: 'Company',
			flex: 1.5,
			minWidth: 180,
		},
		{
			field: 'sector',
			headerName: 'Sector',
			flex: 1,
			minWidth: 140,
		},
		{
			field: 'industry',
			headerName: 'Industry',
			flex: 1,
			minWidth: 160,
		},
	];

	return (
		<Box sx={{ height: 'calc(100vh - 310px)', width: '100%' }}>
			<DataGrid
				rows={companies ?? []}
				columns={columns}
				loading={isLoading}
				density="compact"
				disableSelectionOnClick
				components={{ Toolbar: AdminQuickFilterToolbar }}
				componentsProps={{ toolbar: { showQuickFilter: true } }}
			/>
		</Box>
	);
}
